import {Box} from '@viptech/react-components'
import {useState} from 'react'
import FadeBox from 'src/components/FadeBox'
import PhotoCard from 'src/pages/facial-recognition/components/PhotoCard'
import CloseIcon from 'src/images/closeIconSmallWhite.svg'

export default function MiniThumbnail({
  src,
  thumbnail,
  setThumbnail,
  onDelete,
}: {
  thumbnail?: string
  src: string
  onDelete?: () => void
  setThumbnail: (thumbnail: string) => void
}) {
  const [isHoveringPhoto, setIsHoveringPhoto] = useState(false)

  const onMouseEnter = () => setIsHoveringPhoto(true)
  const onMouseLeave = () => setIsHoveringPhoto(false)

  return (
    <PhotoCard
      onClick={() => setThumbnail(src)}
      width='64px'
      height='64px'
      src={src}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      style={{
        borderRadius: '4px',
        userSelect: 'none',
      }}>
      {onDelete && (
        <FadeBox isUnmounting={!isHoveringPhoto} onFadeOutComplete={onMouseLeave} opacityLimit={15}>
          <Box
            justify='center'
            width='fit-content'
            paddingTop='6px'
            justifyContent='flex-end'
            paddingRight='6px'
            align='center'
            display='flex'
            marginLeft='auto'
            style={{zIndex: 4}}
            onClick={(e) => {
              onDelete()
              e.stopPropagation()
            }}>
            <img src={CloseIcon} alt='close' width={14} height={14} style={{userSelect: 'none'}} />
          </Box>
        </FadeBox>
      )}

      {src === thumbnail && (
        <Box border='3px solid #009EFF' borderRadius='4px' style={{zIndex: 3, pointerEvents: 'none'}} position='absolute' width='58px' height='58px' />
      )}
    </PhotoCard>
  )
}
